import { useState, useEffect } from 'react';
import { fmtRemaining } from '@/lib/time';

// Ticks every minute so the remaining time updates live without a page reload.
export default function LiveCountdown({ deadline, className = '' }) {
  const [label, setLabel] = useState(() => fmtRemaining(deadline));
  useEffect(() => {
    setLabel(fmtRemaining(deadline));
    const id = setInterval(() => setLabel(fmtRemaining(deadline)), 60000);
    return () => clearInterval(id);
  }, [deadline]);
  if (!label) return null;
  return <span className={className} data-testid="live-countdown">{label}</span>;
}
